import pick from 'lodash/pick';

import { generateEmptyWorkspace } from '../../DesktopOnboardingWizard/Workspaces/utils';

function generateWorkspacesFromRecurringMeetings(recurringMeetings) {
  return recurringMeetings.map(({ uuid, teammateName, name, isGroup, attendees }) => ({
    ...generateEmptyWorkspace(),
    recurring_meeting_uuid: uuid,
    fullName: teammateName,
    isGroup,
    attendees,
    name,
  }));
}

export const WorkspaceWhiteList = Object.freeze([
  'uuid',
  'avatar',
  'fullName',
  'isGroup',
  'name',
  'attendees',
  'recurring_meeting_uuid',
  'email',
  'emails',
  'teammateEmail',
  'personalMessage',
]);

export function outputWorkspacesDecorator({ workspaces, recurringMeetings }) {
  const recurringMeetingsUuids = recurringMeetings.map(({ uuid }) => uuid);

  return [
    ...workspaces.filter(
      ({ uuid, fullName, recurring_meeting_uuid }) =>
        (uuid && fullName && !recurring_meeting_uuid) ||
        (recurring_meeting_uuid && !recurringMeetingsUuids.includes(recurring_meeting_uuid))
    ),
    ...generateWorkspacesFromRecurringMeetings(recurringMeetings.filter(({ selected }) => selected)),
  ].map(workspace => pick(workspace, WorkspaceWhiteList));
}

export function getInitialRecurringMeetings({ initRecurringMeetings, initWorkspaces }) {
  return initRecurringMeetings.map(recurringMeeting => ({
    ...recurringMeeting,
    selected: initWorkspaces?.length
      ? initWorkspaces.some(({ recurring_meeting_uuid }) => recurring_meeting_uuid === recurringMeeting.uuid)
      : false,
  }));
}

export function getInitialWorkspaces({ initWorkspaces = [] }) {
  return initWorkspaces.map(workspace => ({
    ...workspace,
    selected: !workspace.recurring_meeting_uuid,
  }));
}
